module.exports = __webpack_public_path__ + "img/globe.c2b0712b.svg";